import { TabAnimationSettings } from "@syncfusion/ej2-angular-navigations";

export class TabConstantsFactory {
    public static createStandardAnimationSettings() {
        return {
            previous: { effect: "", duration: 0, easing: "" },
            next: { effect: "", duration: 0, easing: "" }
        }
    }
}
